import {Component, Inject, OnInit} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {FieldGroupService} from '../../services/field-group/field-group.service';
import {FieldGroupsResponse} from '../../interfaces/FieldGroupsResponse';
import {FieldGroup} from '../../interfaces/FieldGroup';
import {Field} from '../../interfaces/Field';

@Component({
  selector: 'app-field-selector-dialog',
  templateUrl: './field-selector-dialog.component.html',
  styleUrls: ['./field-selector-dialog.component.scss']
})
export class FieldSelectorDialogComponent {

  stage = 1;
  previousStage = 0;
  fieldGroupsResponse: FieldGroupsResponse;
  fieldGroup: FieldGroup;
  type: number;

  private fieldObject = [];

    /**
     *
     * @param {MdDialogRef<FieldSelectorDialogComponent>} dialogRef
     * @param {FieldGroupService} fieldGroupService
     * @param {DialogData} data
     */
  constructor(public dialogRef: MdDialogRef<FieldSelectorDialogComponent>,
              private fieldGroupService: FieldGroupService,
            @Inject(MD_DIALOG_DATA) public data: DialogData,
              ) {
      this.createForm();
  }

    /**
     * Build out the basic form elements needed
     */
  createForm() {
    // if there is no starting field group then it is not useful to show stage one. skip to stage 2
    if (!this.data.parent && !this.data.fieldGroup) {
      this.stage = 2;
      this.previousStage = 1;
    }
      // When creating this form if there is a parent field then we skip straight to the final screen
      if (typeof this.data.fieldGroup !== 'undefined') {
          this.selectField(this.data.fieldGroup, 1);
      }
    }

    /**
     * Handles the clicking of the return button
     */
  returnClicked() {
      // if there is no field group to begin with then we should close because stage one is not useful
      if (!this.data.parent && !this.data.fieldGroup && this.previousStage === 1) {
          this.dialogRef.close();
      }
      // We set the behaviour of the return button to flip to the last page or to close if the last page is 0
    if (this.previousStage === 0)
      this.dialogRef.close();
    this.stage = this.previousStage;
    this.previousStage--;
  }

    /**
     * Gets a list of one type of field group
     * @param {number} type Indicates the type of field group to return
     */
  getFieldGroups(type: number) {
      this.fieldGroupService
          // The limit and page are set to 99 and 1 to make sure the list of field groups is as complete as possible
          .getFieldGroups(99, 1, type)
          .then((response: FieldGroupsResponse) => {
                // We store the list of field groups of whatever sort we picked and then switch the visible elements
              this.fieldGroupsResponse = response;
              this.stage = 3;
              this.previousStage = 2;
              this.type = type;
          });
  }

    /**
     * Selects a field group and handles the list of fields associated with it
     * @param {number} id The identifier of the field group we want to explore
     * @param {number} previous The indicator of the page previous to this one
     */
  selectField(id: number, previous: number) {
      this.fieldGroupService
          .getFieldGroup(id)
          .then((response: FieldGroup) => {
              // We set the field group we selected and advance to the next set of visible elements
              this.fieldGroup = response;
              this.stage = 4;
              this.previousStage = previous;
              this.fieldObject['fieldGroup'] = id;
              console.log(response);
          });
  }


    /**
     * Handles the selection of a field and the closing of the dialog box
     * @param {Field} field
     */
  fieldSelected(field: Field) {
      // When a field is selected we set that field and return the field object, closing this dialog box
      this.fieldObject['field'] = field;
      this.fieldObject['type'] = this.type;
      console.log(this.fieldObject);
      this.dialogRef.close(this.fieldObject);
  }

    /**
     * handles the process of going to the fields parent field group
     */
  goToParent() {
      // We go to the parent field group of the field we're currently editing, displaying the fields associated with it
      this.type = 1;
      this.selectField(this.data.parent, 1);
  }
}

interface DialogData {
    fieldGroup?: number;
    parent: number

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/components/field-selector-dialog/field-selector-dialog.component.ts